import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=e56d2900&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style1 from "./Email.vue?vue&type=style&index=1&id=e56d2900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56d2900",
  null
  
)

export default component.exports